import {
  validateLength,
  validateFormat,
  validateInclusion,
} from 'ember-changeset-validations/validators';
import { CUSTOM_SUBDOMAIN_OPTIONS } from 'uplisting-frontend/models/direct-booking-configuration';

export const DudaConfigurationValidation = {
  // Duda rejects a site's domain prefix outside 4-44 characters:
  // https://developer.duda.co/reference/sites-create-site
  subdomain: [
    validateLength({ min: 4, max: 44 }),
    validateFormat({ regex: /^[a-z0-9]{1}[a-z0-9-]+$/i, allowBlank: true }),
  ],

  customDomain: [
    validateLength({ min: 3, max: 63 }),
    validateFormat({
      regex: /^[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i,
      allowBlank: true,
    }),
  ],

  customSubdomainOption: validateInclusion({
    list: CUSTOM_SUBDOMAIN_OPTIONS,
  }),
};
